import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Purchase {
  name: string;
  city: string;
  pack: 'completo' | 'basico';
  timeAgo: string;
}
const buyers = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Santiago',
  city: 'Córdoba'
}, {
  name: 'Tomás',
  city: 'Rosario'
}, {
  name: 'Joaquín',
  city: 'Mendoza'
}, {
  name: 'Facundo',
  city: 'La Plata'
}, {
  name: 'Gonzalo',
  city: 'Mar del Plata'
}, {
  name: 'Lautaro',
  city: 'Tucumán'
}, {
  name: 'Ramiro',
  city: 'Salta'
}, {
  name: 'Ignacio',
  city: 'Santa Fe'
}, {
  name: 'Valentín',
  city: 'Neuquén'
}];
const timeAgos = ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 15 min', 'hace 1 min', 'hace 3 min'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState<Purchase>({
    name: '',
    city: '',
    pack: 'basico',
    timeAgo: ''
  });
  const packToggle = useRef<boolean>(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNext();
    }, 4000);
    return () => clearTimeout(initialDelay);
  }, []);
  const showNext = () => {
    const buyer = buyers[Math.floor(Math.random() * buyers.length)];
    const timeAgo = timeAgos[Math.floor(Math.random() * timeAgos.length)];
    const pack = packToggle.current ? 'completo' : 'basico';
    packToggle.current = !packToggle.current;
    setCurrent({
      name: buyer.name,
      city: buyer.city,
      pack,
      timeAgo
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 4000) + 6000;
      setTimeout(showNext, nextDelay);
    }, 3500);
  };
  const isCompleto = current.pack === 'completo';
  const packLabel = isCompleto ? 'Mega Pack Ingreso a Fuerzas Completo' : 'Mega Pack Ingreso a Fuerzas';
  return <AnimatePresence data-id="element-182">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 350,
      damping: 28
    }} className="fixed bottom-4 left-4 z-50" data-id="element-183">
          <div className="rounded-lg px-3.5 py-2.5 flex items-center gap-3 max-w-[300px] border" style={{
        background: '#0a0a0a',
        borderColor: isCompleto ? '#d4a017' : '#3b82f6',
        boxShadow: isCompleto ? '0 4px 24px rgba(212, 160, 23, 0.25)' : '0 4px 24px rgba(59, 130, 246, 0.25)'
      }} data-id="element-184">
            {/* Icon */}
            <div className="flex-shrink-0" data-id="element-185">
              <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{
            background: isCompleto ? 'rgba(212, 160, 23, 0.15)' : 'rgba(59, 130, 246, 0.15)'
          }} data-id="element-186">
                <span className="text-sm" data-id="element-187">{isCompleto ? '⭐' : '🛒'}</span>
              </div>
            </div>

            <div className="min-w-0" data-id="element-188">
              <p className="text-white text-xs font-semibold leading-tight truncate" data-id="element-189">
                {current.name} de {current.city}
              </p>
              <p className="text-gray-400 text-[11px] leading-tight mt-0.5" data-id="element-190">
                compró el{' '}
                <span className="font-bold" style={{
              color: isCompleto ? '#d4a017' : '#60a5fa'
            }} data-id="element-191">
                  {packLabel}
                </span>
              </p>
              <p className="text-gray-500 text-[10px] mt-0.5 flex items-center gap-1" data-id="element-192">
                <span className="inline-block w-1.5 h-1.5 rounded-full animate-pulse" style={{
              backgroundColor: isCompleto ? '#d4a017' : '#3b82f6'
            }} data-id="element-193"></span>
                {current.timeAgo}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}